/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useEffect } from "react";

// Hook
export function useWindowResize(handler: () => void): any {
  useEffect(() => {
    // function to call on event
    const listener = () => {
      handler();
    };

    // Add event listener
    window.addEventListener("resize", listener);
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", listener);
  }, []);
}
